/*
* RULES
*
* How to create a rule ?
* A rule is a function that returns an anonymous function taking "value" and "data" as parameters. This function returns an array [boolean, string, boolean].
*
* The parameters are:
* 1. Is valid ?
* 2. Error message
* 3. Continue ?
*/

export const nullable = () => {
    return (value) => {
        return [
            true,
            '',
            value.length > 0
        ];
    };
};

export const required = (message) => {
    return (value) => [
        value.length > 0,
        message ?? 'Veuillez remplir ce champ.',
        true
    ];
};

export const email = () => {
    const regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return (value) => [
        regex.test(value.toLowerCase()),
        'Veuillez saisir une adresse e-mail valide.',
        true
    ];
};

export const minLength = (min) => {
    return (value) => [
        value.length >= min,
        `Veuillez saisir au minimum ${min} caractères.`,
        true
    ];
};

export const maxLength = (max) => {
    return (value) => [
        value.length <= max,
        `Veuillez saisir au maximum ${max} caractères.`,
        true
    ];
};

export const length = (excepted) => {
    return (value) => [
        value.length === excepted,
        `Veuillez saisir ${excepted} caractères.`,
        true
    ];
};

export const oneOf = (items) => {
    return (value) => [
        items.includes(value),
        'Valeur incorrecte.',
        true
    ]
};

export const numeric = () => {
    return (value) => [
        /^-?\d+\.?\d*$/.test(value),
        'Veuillez saisir une valeur numérique.',
        true
    ];
};

export const siret = () => {
    return (value) => {
        value = value.replace(/ /g, '');
        return [
            /[0-9]+/.test(value) && value.length === 14,
            'Veuillez saisir un siret valide.',
            true
        ];
    };
};

export const naf = () => {
    return (value) => [
        /([0-9]{4})([A-Z]){1}/.test(value.toUpperCase()),
        'Veuillez saisir un code naf valide.',
        true
    ];
};

export const phone = () => {
    return (value) => {
        value = value.replace(/ /g, '');
        return [
            /^[+](\d{3})\)?(\d{3})(\d{5,6})$|^(\d{10,10})$/.test(value),
            'Veuillez saisir un téléphone valide.',
            true
        ]
    }
};

export const same = (otherField, message) => {
    return (value, data) => [
        value === data[otherField],
        message ?? 'Les deux valeurs ne correspondent pas.',
        true
    ];
};

export default {nullable, required, email, minLength, maxLength, same, length, oneOf, numeric, siret, naf, phone};
